import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { Tooltip } from "primereact/tooltip";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useFetchActualRoadMeasureResultsQuery, useFetchMeasureLineCountQuery, useFetchMeasureTypesQuery, useFetchRoadMeasureResultsMultipleFiltersQuery, useFetchRoadMeasuresMultipleFiltersQuery } from "../../../api/rtk/base/slices/diagnosticsApiSlice";
import { formatDate, transformResponse } from "../../../features/dataFormatFunctions/dataFormatter";
import { getItemWebStorage } from "../../../features/webStorageSaver/webStorageSaver";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { setCurrentMeasureAdmissibleValue, setCurrentMeasureLessIsBetterMark, setCurrentMeasureUnit, setCurrentRoadMeasureResultsType } from "../../../stateManagement/reducers/diagnostics/DiagnosticsSlice";
import { store } from "../../../stateManagement/store";
import { Loader } from "../../loaders/Loader";
import { TableExportComponent } from "../../tablesShared/tableTools/tableExportComponent";
import { RoadMeasureTypeToColumns } from "../diagnosticsSegmentsSection/diagnosticsSegmentsContent/RoadMeasureResultsTypesColumns";
import { DiagnosticsMeasureResultsTable } from "./DiagnosticsMeasureResultsTable";
import { setTableInfoWindowIsShown } from "../../../stateManagement/reducers/ContentHeaderSlice";
import ToastMessageContainer from "../../toastMessageContainer/ToastMessageContainer";
import { setToastMessageContainerClearButtonIsClicked, showToastMessage } from "../../../stateManagement/reducers";

const close_icon = require('../../../assets/images/icons/close_icon.png')

const RoadMeasureResultsColumnsPattern: any = [
    {
        headerName: "Км",
        pdfHeader: "Км",
        field: "Position",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Км+",
        pdfHeader: "Км+",
        field: "MaintenancePosition",
        valueType: "int",
        canBeFiltered: false,
        filterType: "equals",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        field: 'AdmissibleValue',
        hidden: true
    },
    {
        field: 'LessIsBetter',
        hidden: true
    }
]

const measureTypeIdDict: any = {
    'RoadMeasureRoughness': 3055,
    'DefectSegmentGOST': 'RoadDefect',
    'DefectSegmentODM': 'RoadDefect',
    'RoadMeasureGaugeDepth': 3058,
    'RoadMeasureStrength': 3056,
    'RoadMeasureCohesion': 3057
}

const dontHaveLineValuesEndpoint = ['RoadMeasureProfile', 'RoadMeasureVisibility', 'RoadMeasureCurveRadius', 'RoadMeasureTrafficIntensity', 'RoadMeasureLongitudinalSlopes', 'RoadMeasureLightings', 'RoadMeasureRoadbedComplexs', 'RoadMeasureRoadbeds',
    'RoadMeasureAutomaticTrafficIntensity', 'RoadMeasureDurtyingWidth', 'RoadMeasureElevation', 'RoadMeasureScan', 'RoadMeasureTrafficIntensity', 'RoadMeasureTransportTrafficIntensity', 'RoadMeasureTrafficIntensityGost']

// Компонент - содержимое вкладки Диагностика -> Участки диагностики
export function DiagnosticsMeasureResultsTableWrapper() {
    const { measureType }: any = useParams()
    const navigate = useNavigate();
    const measureTypeId = measureTypeIdDict[measureType]
    const [currentMeasureId, setCurrentMeasureId] = useState<any>();
    const dispatch = useDispatch()
    const isMobileWindow = window.innerWidth < 767;
    let actualMeasureResultsMark = false;
    const [expandList, setExpandList] = useState<boolean>(true)
    let periodMinFilter, periodMaxFilter;
    const period = useAppSelector(state => state.diagnosticsRoadMeasureResults.period)
    let filterStringArray: any = []
    let exportFilterStringArray: any = []
    if (period?.includes('-')) {
        periodMinFilter = period.split('-')[0]
        periodMaxFilter = period.split('-')[1]
        filterStringArray.push(`EventStartDate le ${periodMaxFilter}-12-31`)
        filterStringArray.push(`EventStartDate ge ${periodMinFilter}-01-01`)
        actualMeasureResultsMark = true
    } else {
        filterStringArray.push(`EventStartDate le ${period}-12-31`)
        filterStringArray.push(`EventStartDate ge ${period}-01-01`)
    }

    useEffect(() => {
        if (!measureTypeIdDict[measureType]) {
            navigate('/app/error')
        }
    }, [measureType])

    let tableColumns: any = []
    let tableFilters: any = []
    let way: any = ''
    let tableValueForLength: any = 0;
    let hasLineValues: boolean = false
    let configOfLines = ''

    const { pathId } = useAppSelector(state => state.pathsInfo.selectedPath) ?? {}
    const { data: measureTypes, isLoading: loadingMeasureTypes } = useFetchMeasureTypesQuery({})
    let headerGroup: any
    let hasRightLeftValues: any
    let measureTypeClassName: any = measureTypes && measureTypes.filter((item: any) => item.ClassId == measureTypeId)[0]?.ClassName
    let objectType: any = measureTypes && measureTypeClassName
    let defectClassificator: any

    if (measureTypeId !== 'RoadDefect') {
        if (dontHaveLineValuesEndpoint.includes(objectType)) {
            objectType = measureTypes && objectType?.replace('Measure', 'Measures')
        } else {
            objectType = objectType + 'LineValues'
        }
        way = `diagnostics/${objectType}`
        hasRightLeftValues = objectType === 'RoadMeasureGaugeDepthLineValues'
    } else {
        objectType = measureType
        way = `diagnostics/DefectSegments`
        if (measureType === 'DefectSegmentGOST') {
            defectClassificator = 4
        } else if (measureType === 'DefectSegmentODM') {
            defectClassificator = 5
        }
    }
    if (actualMeasureResultsMark) {
        if (measureTypeId !== 'RoadDefect') {
            way = `diagnostics/Nearest${measureType?.replace('RoadMeasure', '')}`
        } else {
            way = `diagnostics/NearestDefectSegments`
        }
    }

    function clearCurrentRoadMeasureStoreInfo() {
        dispatch(setCurrentRoadMeasureResultsType(null))
        dispatch(setCurrentMeasureUnit(null))
        dispatch(setCurrentMeasureAdmissibleValue(null))
        dispatch(setCurrentMeasureLessIsBetterMark(null))
    }

    const {
        data: roadMeasures,
        isFetching: fetchingRoadMeasures,
        isError: isErrorMeasures,
        isSuccess: isSuccessRoadMeasures
    } = useFetchRoadMeasuresMultipleFiltersQuery(
        {
            pathId,
            way,
            top: '',
            pages: true,
            filterStringArray: [...filterStringArray, `MeasureTypeId eq ${measureTypeId}`],
            skip: 0,
            order: 'EventStartDate'
        },
        { skip: (!measureTypes || measureTypeId === 'RoadDefect' || actualMeasureResultsMark) })

    useEffect(() => {
        setCurrentMeasureId(roadMeasures?.value.find((item: any) => item.MeasureId != null)?.MeasureId)
        if (roadMeasures?.value[0]) {
            dispatch(setCurrentRoadMeasureResultsType(roadMeasures?.value[0]?.MeasureTypeString))
            dispatch(setCurrentMeasureUnit(roadMeasures?.value[0]?.MeasureUnit))
            dispatch(setCurrentMeasureAdmissibleValue(roadMeasures?.value[0]?.AdmissibleValue))
            dispatch(setCurrentMeasureLessIsBetterMark(roadMeasures?.value[0]?.LessIsBetter))
        }
    }, [roadMeasures])

    useEffect(() => {
        if (fetchingRoadMeasures) {
            setCurrentMeasureId(null)
        }
    }, [fetchingRoadMeasures])

    let tableValue: any = []
    const {
        data: actualMeasureResults,
        isFetching: fetchingActualMeasureResults,
        isError: isErrorActualMeasureResults,
        isSuccess: isSuccessActualResults
    } = useFetchActualRoadMeasureResultsQuery(
        {
            pathId,
            way,
            top: 1,
            pages: true,
            filterStringArray: [...filterStringArray],
            skip: 0,
            order: ''
        },
        { skip: (measureTypeId === 'RoadDefect' || !actualMeasureResultsMark) })

    const {
        data: actualRoadDefects,
        isFetching: fetchingActualRoadDefects,
        isError: isErrorActualRoadDefectss,
        isSuccess: isSuccessActualRoadDefects
    } = useFetchActualRoadMeasureResultsQuery(
        {
            pathId,
            way,
            top: 1,
            pages: true,
            // filterStringArray: [...filterStringArray, `DefectClassificator eq ${defectClassificator}`],
            filterStringArray: [...filterStringArray],
            skip: 0,
            order: ''
        },
        { skip: (measureTypeId !== 'RoadDefect' || !actualMeasureResultsMark) })

    const {
        data: roadMeasureResults,
        isFetching,
        isFetching: fetchingRoadMeasureResults,
        isError,
        isSuccess: isSuccessResults
    } = useFetchRoadMeasureResultsMultipleFiltersQuery(
        {
            pathId,
            way,
            top: 1,
            pages: true,
            filterStringArray: [`MeasureId eq ${currentMeasureId}`],
            skip: 0
        },
        { skip: (!measureTypes || !currentMeasureId || measureTypeId === 'RoadDefect' || actualMeasureResultsMark) })

    const {
        data: defectSegments,
        isFetching: fetchingDefectSegments,
        isUninitialized: isUninitializedDefectSegments,
        isSuccess: isSuccessDefectSegments
    } = useFetchRoadMeasureResultsMultipleFiltersQuery(
        {
            pathId,
            way: 'diagnostics/DefectSegments',
            top: 1,
            pages: true,
            // filterStringArray: [...filterStringArray, `DefectClassificator eq ${defectClassificator}`],
            filterStringArray: [...filterStringArray],
            skip: 0
        },
        { skip: (measureTypeId !== 'RoadDefect' || actualMeasureResultsMark) })

    if (!actualMeasureResultsMark && currentMeasureId && roadMeasureResults?.value.length > 0) {
        tableValue = transformResponse(roadMeasureResults).value
        const currentMeasure = roadMeasures?.value.find((measure: any) => measure.MeasureId === currentMeasureId)
        if (currentMeasure) {
            dispatch(setCurrentRoadMeasureResultsType(currentMeasure?.MeasureTypeString))
            dispatch(setCurrentMeasureUnit(currentMeasure?.MeasureUnit))
            dispatch(setCurrentMeasureAdmissibleValue(currentMeasure?.AdmissibleValue))
            dispatch(setCurrentMeasureLessIsBetterMark(currentMeasure?.LessIsBetter))
        }
        exportFilterStringArray.push(`MeasureId eq ${currentMeasureId}`)
    }
    if (!actualMeasureResultsMark && defectClassificator && defectSegments?.value.length > 0) {
        tableValue = transformResponse(defectSegments).value
        clearCurrentRoadMeasureStoreInfo()
        exportFilterStringArray = filterStringArray.slice()
        // exportFilterStringArray.push(`DefectClassificator eq ${defectClassificator}`)
    }
    if (actualMeasureResultsMark && measureTypeId !== 'RoadDefect' && actualMeasureResults?.value.length > 0) {
        tableValue = transformResponse(actualMeasureResults).value
        exportFilterStringArray = filterStringArray.slice()
    }
    if (actualMeasureResultsMark && measureTypeId == 'RoadDefect' && actualRoadDefects?.value.length > 0) {
        tableValue = transformResponse(actualRoadDefects).value
        clearCurrentRoadMeasureStoreInfo()
        exportFilterStringArray = filterStringArray.slice()
        // exportFilterStringArray.push(`DefectClassificator eq ${defectClassificator}`)
    }
    if (isSuccessResults && roadMeasures?.value.length == 0) {
        tableValue = []
        setCurrentMeasureId(null)
        clearCurrentRoadMeasureStoreInfo()
    }
    if (isSuccessDefectSegments && defectSegments?.value.length == 0) {
        tableValue = []
        clearCurrentRoadMeasureStoreInfo()
    }
    if (isSuccessActualResults && actualMeasureResults?.value.length == 0) {
        tableValue = []
    }
    if (isSuccessActualRoadDefects && actualRoadDefects?.value.length == 0) {
        tableValue = []
        clearCurrentRoadMeasureStoreInfo()
    }
    if (currentMeasureId && !actualMeasureResultsMark) {
        tableValueForLength = roadMeasureResults
    }
    if (defectClassificator && !actualMeasureResultsMark) {
        tableValueForLength = defectSegments
    }
    if (actualMeasureResultsMark && measureTypeId !== 'RoadDefect') {
        tableValueForLength = actualMeasureResults
    }
    if (actualMeasureResultsMark && measureTypeId == 'RoadDefect') {
        tableValueForLength = actualRoadDefects
    }

    const { data: measureLineCount } = useFetchMeasureLineCountQuery(
        {
            pathId,
            measureTypeId,
            minYear: periodMinFilter,
            maxYear: periodMaxFilter,
            forNearest: true
        },
        { skip: (measureTypeId === 'RoadDefect' || !actualMeasureResultsMark) })

    let reverseLineCount, forwardLineCount
    if (actualMeasureResultsMark && measureTypeId !== 'RoadDefect') {
        reverseLineCount = measureLineCount?.ReverseLineCount
        forwardLineCount = measureLineCount?.ForwardLineCount
    } else if (!actualMeasureResultsMark && measureTypeId !== 'RoadDefect') {
        reverseLineCount = tableValue.find((value: any) => value.ReverseLineCount !== null)?.ReverseLineCount
        forwardLineCount = tableValue.find((value: any) => value.ForwardLineCount !== null)?.ForwardLineCount
    }

    if (measureTypeId !== 'RoadDefect') {
        if (objectType.includes('LineValues') && (roadMeasureResults || actualMeasureResults) && measureTypes && (roadMeasureResults?.value?.length > 0 || actualMeasureResults?.value?.length > 0)) {
            hasLineValues = true
            let reverseLines = []
            let forwardLines = []
            for (let i = 8 - reverseLineCount + 1; i < 9; i++) {
                reverseLines.push(`Reverse${i}`)
            }
            for (let i = 1; i <= forwardLineCount; i++) {
                forwardLines.push(`Forward${i}`)
            }
            const allLines = [...reverseLines, ...forwardLines]
            let leftRightColumns: any = []
            allLines.map((item) => {
                leftRightColumns.push({
                    header: 'Левая',
                    colspan: 1,
                    align: 'center',
                    sortable: true,
                    field: `${item}Value`
                })
                leftRightColumns.push({
                    header: 'Правая',
                    colspan: 1,
                    align: 'center',
                    sortable: true,
                    field: `${item}AdditionalValue`
                })
            })
            headerGroup = (
                <ColumnGroup>
                    <Row>
                        <Column header="Местоположение" colSpan={2} align="center" />
                        {reverseLineCount > 0 &&
                            <Column header="Обратное направление" colSpan={hasRightLeftValues ? reverseLineCount * 2 : reverseLineCount} align="center" />
                        }
                        {forwardLineCount > 0 &&
                            <Column header="Прямое направление" colSpan={hasRightLeftValues ? forwardLineCount * 2 : forwardLineCount} align="center" />
                        }
                    </Row>
                    <Row>
                        <Column header="Км" colSpan={1} rowSpan={hasRightLeftValues ? 2 : 1} align="center" field="Position" />
                        <Column header="Км+" colSpan={1} rowSpan={hasRightLeftValues ? 2 : 1} align="center" field="MaintenancePosition" />
                        {reverseLines.map((item: any, index) => {
                            let lineNumber = index + 1
                            if (hasRightLeftValues) {
                                return (
                                    <Column header={lineNumber} colSpan={hasRightLeftValues ? 2 : 1} align="center" key={index} />
                                )
                            } else {
                                return (
                                    <Column header={lineNumber} colSpan={hasRightLeftValues ? 2 : 1} align="center" field={`${item}Value`} key={index} />
                                )
                            }
                        })}
                        {forwardLines.map((item: any, index) => {
                            let lineNumber = reverseLines.length + index + 1;
                            if (hasRightLeftValues) {
                                return (
                                    <Column header={lineNumber} colSpan={hasRightLeftValues ? 2 : 1} align="center" key={index} />
                                )
                            } else {
                                return (
                                    <Column header={lineNumber} colSpan={hasRightLeftValues ? 2 : 1} align="center" field={`${item}Value`} key={index} />
                                )
                            }
                        })}
                    </Row>
                    {hasRightLeftValues &&
                        <Row>
                            {leftRightColumns.map((item: any) => {
                                return (
                                    <Column header={item.header} colSpan={1} align={item.align} sortable={false} field={item.field} key={item} />
                                )
                            })}
                        </Row>
                    }
                </ColumnGroup>
            );
            tableColumns = RoadMeasureResultsColumnsPattern.slice()
            if (hasRightLeftValues) {
                leftRightColumns.map((item: any) => {
                    tableColumns.push(
                        {
                            headerName: item.header,
                            pdfHeader: item.header,
                            field: item.field,
                            valueType: "float",
                            canBeFiltered: true,
                            filterType: "equals",
                            canBeSorted: true,
                            showFilterMenu: true,
                            width: 40,
                            align: "left"
                        },
                    )
                })
            } else {
                reverseLines.map((item: any, index) => {
                    const lineNumber = index + 1
                    tableColumns.push(
                        {
                            headerName: lineNumber,
                            pdfHeader: lineNumber,
                            field: `${item}Value`,
                            valueType: "float",
                            canBeFiltered: true,
                            filterType: "equals",
                            canBeSorted: true,
                            showFilterMenu: true,
                            width: 40,
                            align: "left"
                        },
                    )
                })
                forwardLines.map((item: any, index) => {
                    const lineNumber = reverseLines.length + index + 1
                    tableColumns.push(
                        {
                            headerName: lineNumber,
                            pdfHeader: lineNumber,
                            field: `${item}Value`,
                            valueType: "float",
                            canBeFiltered: true,
                            filterType: "equals",
                            canBeSorted: true,
                            showFilterMenu: true,
                            width: 40,
                            align: "left"
                        },
                    )
                })
            }

            configOfLines = `Forward${forwardLines.length}Reversed${reverseLines.length}`

        } else if (!objectType.includes('LineValues') && roadMeasureResults && measureTypes) {
            hasLineValues = false
            let additionalColumns: any = []
            additionalColumns = RoadMeasureTypeToColumns[objectType]?.slice()
            tableColumns = objectType && [...RoadMeasureResultsColumnsPattern, ...additionalColumns]
            headerGroup = (
                <ColumnGroup>
                    <Row>
                        <Column header="Местоположение" colSpan={2} align="center" />
                        <Column header="Доп. параметры" colSpan={tableColumns.length} align="center" />
                    </Row>
                    <Row>
                        {tableColumns.map((item: any) => {
                            return <Column header={item.headerName} colSpan={1} align="center" sortable field={item.field} />
                        })}
                    </Row>
                </ColumnGroup>
            );
        }
    } else {
        tableColumns = RoadMeasureTypeToColumns[measureType]?.slice()
        if (measureType === 'DefectSegmentGOST') {
            headerGroup = (
                <ColumnGroup>
                    <Row>
                        <Column header="Начало" colSpan={2} align="center" />
                        <Column header="Конец" colSpan={2} align="center" />
                        <Column header="Дефекты слева" rowSpan={2} colSpan={1} align="center" />
                        <Column header="Дефекты справа" rowSpan={2} colSpan={1} align="center" />
                    </Row>
                    <Row>
                        <Column header="Км" colSpan={1} rowSpan={hasRightLeftValues ? 2 : 1} align="center" field="Position" />
                        <Column header="Км+" colSpan={1} rowSpan={hasRightLeftValues ? 2 : 1} align="center" field="MaintenancePosition" />
                        <Column header="Км" colSpan={1} rowSpan={hasRightLeftValues ? 2 : 1} align="center" field="Ending" />
                        <Column header="Км+" colSpan={1} rowSpan={hasRightLeftValues ? 2 : 1} align="center" field="MaintenanceEnding" />
                    </Row>
                </ColumnGroup>
            );
        } else if (measureType === 'DefectSegmentODM') {
            headerGroup = (
                <ColumnGroup>
                    <Row>
                        <Column header="Начало" colSpan={2} align="center" />
                        <Column header="Конец" colSpan={2} align="center" />
                        <Column header="Оценка в баллах" rowSpan={2} colSpan={1} align="center" />
                    </Row>
                    <Row>
                        <Column header="Км" colSpan={1} rowSpan={hasRightLeftValues ? 2 : 1} align="center" field="Position" />
                        <Column header="Км+" colSpan={1} rowSpan={hasRightLeftValues ? 2 : 1} align="center" field="MaintenancePosition" />
                        <Column header="Км" colSpan={1} rowSpan={hasRightLeftValues ? 2 : 1} align="center" field="Ending" />
                        <Column header="Км+" colSpan={1} rowSpan={hasRightLeftValues ? 2 : 1} align="center" field="MaintenanceEnding" />
                    </Row>
                </ColumnGroup>
            );
        }
    }
    // Назначение предопределенных параметров фильтрации столбцов 
    let filters: any = {}
    tableColumns?.map((item: any) => {
        filters[item.field] = { value: null, matchMode: item.filterType }
    })
    tableFilters = filters

    useEffect(() => {
        if (isFetching) {
            dispatch(setToastMessageContainerClearButtonIsClicked(true))
        }
    }, [isFetching])

    useEffect(() => {
        if (isError) {
            dispatch(showToastMessage({ messageText: 'Не удалось загрузить таблицу', messageType: "error" }))
        }
    }, [isError])


    function chooseRoadMeasure(measure: any) {
        if (isMobileWindow) {
            setExpandList(false)
        }
        setCurrentMeasureId(measure.MeasureId)
        if (measure) {
            dispatch(setCurrentRoadMeasureResultsType(measure.MeasureTypeString))
            dispatch(setCurrentMeasureUnit(measure.MeasureUnit))
            dispatch(setCurrentMeasureAdmissibleValue(measure.AdmissibleValue))
            dispatch(setCurrentMeasureLessIsBetterMark(measure.LessIsBetter))
        }
    }

    const roadName = getItemWebStorage('roadDirection')?.roadName
    const pathName = getItemWebStorage('roadDirection')?.pathName
    const tableInfoWindowIsShown = useAppSelector(state => state.contentHeader.tableInfoWindowIsShown)
    const currentRoadMeasureResultsType = store.getState().diagnostics.currentRoadMeasureResultsType
    const currentMeasureAdmissibleValue = store.getState().diagnostics.currentMeasureAdmissibleValue

    let exportName: any
    if (measureTypeId !== 'RoadDefect') {
        exportName = currentRoadMeasureResultsType + '_' + roadName + '_' + pathName + '_' + period + '_'
    } else {
        if (measureType === 'DefectSegmentGOST') {
            exportName = 'Наличие дефектов по ГОСТ Р 50597' + '_' + roadName + '_' + pathName + '_' + period + '_'
        } else if (measureType === 'DefectSegmentODM') {
            exportName = 'Наличие дефектов по ОДМ 218.4.039' + '_' + roadName + '_' + pathName + '_' + period + '_'
        }
    }
    return (
        <div className="h-100">
            <ToastMessageContainer />
            {(fetchingRoadMeasureResults || fetchingRoadMeasures || loadingMeasureTypes || fetchingDefectSegments || fetchingActualMeasureResults || fetchingActualRoadDefects)
                ?
                <Loader />
                :
                <>
                    {isError
                        ?
                        <></>
                        :
                        <>
                            {['pdf', 'csv', 'excel'].map((exportType) => {
                                return (
                                    <TableExportComponent
                                        dataCount={tableValueForLength && tableValueForLength[`@xdata.count`]}
                                        columns={tableColumns}
                                        objectType={objectType}
                                        url={way}
                                        pathId={pathId}
                                        exportType={exportType}
                                        initFilterStringArray={exportFilterStringArray}
                                        initSortQueryArgsParameters={['Position']}
                                        exportName={exportName}
                                    />
                                )
                            })}
                            {tableInfoWindowIsShown &&
                                <div className="table-info">
                                    {!actualMeasureResultsMark
                                        ?
                                        <>
                                            <p style={{ marginBottom: '7px' }}><strong>По дороге:</strong><span style={{ marginLeft: '15px' }} className="table-info-value-diagnostics">{roadName ? roadName : 'Не указано'}</span></p>
                                            <p style={{ marginBottom: '7px' }}><strong>Направление:</strong><span style={{ marginLeft: '15px' }} className="table-info-value-diagnostics">{pathName ? pathName : 'Не указано'}</span></p>
                                            <p style={{ marginBottom: '7px' }}><strong>Дата:</strong><span style={{ marginLeft: '15px' }} className="table-info-value-diagnostics">{period != null ? period : 'Не указано'}</span></p>
                                            <p style={{ marginBottom: '7px' }}><strong>Тип измерения:</strong><span style={{ marginLeft: '15px' }} className="table-info-value-diagnostics">{currentRoadMeasureResultsType != null ? currentRoadMeasureResultsType : 'Не указано'}</span></p>
                                            <p style={{ marginBottom: '7px' }}><strong>Предельно допустимое значение:</strong><span style={{ marginLeft: '15px' }} className="table-info-value-diagnostics">{currentMeasureAdmissibleValue != null ? currentMeasureAdmissibleValue?.toString()?.replace('.', ',') : 'Не указано'}</span></p>

                                            <div className="table-info-close-div" onClick={() => dispatch(setTableInfoWindowIsShown(false))}>
                                                <img src={close_icon} width="25px" height="25px" />
                                            </div>
                                        </>
                                        :
                                        <>
                                            Отсутствует информация
                                        </>
                                    }
                                </div>
                            }
                            <div className="list-table-container">
                                {(measureTypeId !== 'RoadDefect' && !actualMeasureResultsMark && expandList) &&
                                    <div className="road-measures-list">
                                        <div className="road-measures-list-header">
                                            <span>Участки измерений</span>
                                            <Button onClick={() => setExpandList(false)} className="collapse-list-button">
                                                {isMobileWindow
                                                    ?
                                                    <i className="pi pi-angle-double-up" style={{ color: 'black' }}></i>
                                                    :
                                                    <i className="pi pi-angle-double-left" style={{ color: 'black' }}></i>
                                                }

                                            </Button>
                                        </div>
                                        <div className="road-measures-list-values">
                                            {roadMeasures?.value.map((measure: any) => {
                                                return (
                                                    <div style={currentMeasureId === measure.MeasureId ? { backgroundColor: '#27ae5f', color: 'white' } : {}} className="road-measures-list-value" onClick={() => chooseRoadMeasure(measure)} key={measure}>
                                                        <p>{measure.SectionStart?.toFixed(3)?.replace('.', ',')} км - {measure.SectionEnd?.toFixed(3)?.replace('.', ',')} км;</p>
                                                        <p> с {formatDate(measure.EventStartDate)} по {formatDate(measure.EventEndDate)}</p>
                                                    </div>
                                                )
                                            })}
                                            {roadMeasures?.value.length == 0 &&
                                                <div className="no-value-road-measures">
                                                    Данных нет
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                                {(!expandList && !isMobileWindow && measureTypeId !== 'RoadDefect' && !actualMeasureResultsMark) &&
                                    <>
                                        <Tooltip target=".expand-list-button" mouseTrack mouseTrackLeft={10} showDelay={350} />
                                        <Button onClick={() => setExpandList(true)} className="expand-list-button" data-pr-tooltip="Участки измерений">
                                            <i className="pi pi-angle-double-right" style={{ color: 'black' }}></i>
                                        </Button>
                                    </>
                                }
                                {(!expandList && isMobileWindow && measureTypeId !== 'RoadDefect' && !actualMeasureResultsMark) &&
                                    <div className="road-measures-list-header">
                                        <span>Участки измерений</span>
                                        <Button onClick={() => setExpandList(true)} className="collapse-list-button">
                                            <i className="pi pi-angle-double-down" style={{ color: 'black' }}></i>
                                        </Button>
                                    </div>
                                }
                                {(isMobileWindow && (measureTypeId == 'RoadDefect' || actualMeasureResultsMark)) &&
                                    <div className="road-measures-list-header">
                                        <span>Всего записей — {tableValueForLength[`@xdata.count`]} </span>
                                    </div>
                                }
                                <DiagnosticsMeasureResultsTable
                                    columns={tableColumns}
                                    headerGroup={headerGroup}
                                    filters={tableFilters}
                                    type={measureTypeId === 'RoadDefect' ? 'RoadDefects' : 'RoadMeasureResults'}
                                    objectType={objectType}
                                    valueLength={tableValueForLength && tableValueForLength[`@xdata.count`]}
                                    way={way}
                                    pathId={pathId}
                                    hasLineValues={hasLineValues}
                                    configOfLines={configOfLines}
                                    measureId={currentMeasureId}
                                    defectClassificator={defectClassificator}
                                    dateFilters={filterStringArray}
                                    actualMeasureResultsMark={actualMeasureResultsMark}
                                    expandList={expandList}
                                    period={period}
                                />
                            </div>
                        </>


                    }
                </>
            }
        </div>
    );
}

